import { combineReducers } from '@reduxjs/toolkit';
import animations from './animationsReducer';
import bombs from './bombsReducer';
import chat from './chatReducer';
import common from './commonReducer';
import contacts from './contactsReducer';
import createGame from './createGameReducer';
import directMessages from './directMessagesReducer';
import drawer from './drawerReducer';
import footerAlert from './footerAlertReducer';
import gameDimensions from './gameDimensionsReducer';
import gameEntry from './gameEntryReducer';
import gameGuide from './gameGuideReducer';
import history from './historyReducer';
import instanceId from './instanceIdReducer';
import lobby from './lobbyReducer';
import messageBoxes from './messageBoxesReducer';
import mtt from './mttReducer';
import mttStaging from './mttStagingReducer';
import panels from './panelsReducer';
import playerBubbles from './playerBubblesReducer';
import playerInfo from './playerInfoReducer';
import poker from './pokerReducer';
import recoverLogin from './recoverLoginReducer';
import reverify from './reverifyReducer';
import scene from './sceneReducer';
import selfAvatar from './selfAvatarReducer';
import selfData from './selfDataReducer';
import session from './sessionReducer';
import sideBets from './sideBetsReducer';
import theme from './themeReducer';
import toasts from './toastsReducer';
import transitionAnimation from './transitionAnimationReducer';
import verifyAccount from './verifyAccountReducer';
export const rootReducer = combineReducers({
    animations,
    bombs,
    chat,
    common,
    contacts,
    createGame,
    drawer,
    footerAlert,
    gameDimensions,
    gameEntry,
    gameGuide,
    history,
    instanceId,
    lobby,
    messageBoxes,
    mtt,
    mttStaging,
    panels,
    playerBubbles,
    playerInfo,
    poker,
    directMessages,
    recoverLogin,
    reverify,
    scene,
    selfAvatar,
    selfData,
    session,
    sideBets,
    theme,
    toasts,
    transitionAnimation,
    verifyAccount
});
